export default __webpack_public_path__ + "static/media/Mask Group 69.e13b2e50.jpg";